import React, { FC } from 'react';
import { format } from 'date-fns';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvStackedDateTimeProps {
  value: string;
}

const OvStackedDateTime: FC<OvStackedDateTimeProps> = ({ value }) => {
  const date = new Date(value);

  return (
    <Time dateTime={value}>
      <span>{format(date, 'd MMM yyyy')}</span>
      <Secondary>{format(date, 'HH:mm O')}</Secondary>
    </Time>
  );
};

export default OvStackedDateTime;

const Time = styled.time`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
`;

const Secondary = styled.span`
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
`;
